import { mockData as documentAlertConfigData } from '@web/lib/demo/data/documentAlertConfig';
export var createDocumentAlertConfig = function (input) {
    if (!documentAlertConfigData.length) {
        throw new Error('Document alert config not found');
    }
    return documentAlertConfigData[0];
};
